module.exports = __webpack_public_path__ + "img/24.4ae779c0.jpg";